/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {AlertFired, GenericObject} from '@ion/core/src/types/entities';

/**
 * Defines the mappings of AlertsFired severities to their respective iOn
 * Notification Categories:
 *
 *  Urgent             : AlertSeverity.CRITICAL
 *  General            : AlertSeverity.HIGH
 *  TimeRelated        : AlertSeverity.MEDIUM
 *  ConnectivitySignal : AlertSeverity.LOW
 *  ScheduledEvents    : AlertSeverity.SYSTEM
 *
 * @see https://synovia.atlassian.net/browse/ION-375
 */
export enum NotificationCategory {
  Urgent = 'Urgent',
  General = 'General',
  TimeRelated = 'Time Related',
  ConnectivitySignal = 'Connectivity / Signal',
  ScheduledEvents = 'Scheduled Events'
};

/**
 * Defines the mappings of AlertsFired isAcknowledged state to their respective
 * iOn Notification Actions state:
 *
 *  Read     : AlertFired.isAcknowledged === true
 *  Cleared  : AlertFired.?
 *
 * @see https://synovia.atlassian.net/browse/ION-375
 */
export enum NotificationAction {
  Read = 'Read',
  Cleared = 'Cleared'
};

export enum NotificationDetailsType {
  email = 'email',
  sms = 'sms'
};

export interface Notification extends AlertFired {
  category?: NotificationCategory;
  action?: NotificationAction | null;
  isUrgent?: boolean;
  isCleared?: boolean;
  isRead?: boolean;
  details?: GenericObject;
};
